import { AuthState } from './auth.types';

export const initialAuthState: AuthState = {
  user: null,
  loading: true,
};
